import { PaymentAmount, PrimaryGuest, AdjustmentPersistRequest, TripAdjustmentResponse } from 'guest-data-types-ts-lib';
import { PaymentFormValues } from '../components';
import { PaymentRequestWithCardInformation } from 'guest-data-types-ts-lib/types/payment';

export class PaymentUtils {
    public static getCreditCardExpirationYears = () => {
        const currentYear = new Date().getFullYear();
        const expirationYears = [];
        for (let i = 0; i <= 10; i++) {
            expirationYears.push({
                key: (currentYear + i).toString(),
                value: (currentYear + i).toString(),
                name: (currentYear + i).toString(),
            });
        }
        return expirationYears;
    };

    public static getCreditCardExpirationMonths() {
        const expirationMonths = [];
        for (let i = 0; i < 12; i++) {
            let month = (i + 1).toString();
            month = +month > 9 ? month.toString() : `0${month}`;
            expirationMonths.push({
                key: month,
                value: month,
                name: month,
            });
        }
        return expirationMonths;
    }

    public static transformToPersistRequest(
        preview: TripAdjustmentResponse,
        guest: PrimaryGuest,
        amount: number,
        paymentData?: PaymentFormValues
    ): AdjustmentPersistRequest {
        const { adjustment, uuid, delta } = preview;
        return {
            name: adjustment.name,
            uuid: uuid,
            payment: paymentData && {
                amount: {
                    currency: delta.currency || 'USD',
                    total: amount,
                },
                payee: {
                    address: {
                        city: paymentData.city,
                        postalCode: paymentData.zip_code,
                        state: paymentData.state,
                        street1: paymentData.billing_address,
                        country: paymentData.country,
                    },
                },
                paymentInstrument: {
                    nameOnAccount: {
                        first: paymentData.first_name,
                        last: paymentData.last_name,
                    },
                    creditCard: {
                        cardNumber: paymentData.card_number,
                        expirationMonth: paymentData.expiration_month,
                        expirationYear:
                            paymentData.expiration_year.length === 4
                                ? paymentData.expiration_year.substr(2, 2)
                                : paymentData.expiration_year,
                        cvv: paymentData.security_code,
                    },
                },
            },
        };
    }

    public static transformToPayBalance(
        guest: PrimaryGuest,
        amount: PaymentAmount,
        paymentData: PaymentFormValues
    ): PaymentRequestWithCardInformation {
        return {
            amount,
            payee: {
                address: {
                    city: paymentData.city,
                    postalCode: paymentData.zip_code,
                    state: paymentData.state,
                    street1: paymentData.billing_address,
                    country: paymentData.country,
                },
            },
            paymentInstrument: {
                nameOnAccount: {
                    first: paymentData.first_name,
                    last: paymentData.last_name,
                },
                creditCard: {
                    cardNumber: paymentData.card_number,
                    expirationMonth: paymentData.expiration_month,
                    expirationYear: paymentData.expiration_year,
                    cvv: paymentData.security_code,
                },
            },
        };
    }
}
